/**
 * Script de mise à jour du badge de notification pour Master League
 * Ce script intercepte les réponses des API de notification et met à jour le badge en conséquence
 */

document.addEventListener('DOMContentLoaded', function() {
    // Fonction pour mettre à jour le badge
    function updateBadge(count) {
        if ('setAppBadge' in navigator) {
            if (count > 0) {
                navigator.setAppBadge(count)
                    .then(() => console.log(`Badge mis à jour: ${count}`))
                    .catch(error => console.error('Erreur lors de la mise à jour du badge:', error));
            } else {
                navigator.clearAppBadge()
                    .then(() => console.log('Badge effacé'))
                    .catch(error => console.error('Erreur lors de l\'effacement du badge:', error));
            }
        }
    }

    // Vérifier si une réponse est du JSON valide
    function isJsonResponse(response) {
        const contentType = response.headers.get('content-type');
        return contentType && contentType.includes('application/json');
    }

    // Intercepter les requêtes fetch pour mettre à jour le badge
    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
        const promise = originalFetch.apply(this, arguments);
        
        // Vérifier si la requête concerne une notification
        if (typeof url === 'string' && (
            url.includes('/notifications/') || 
            url.includes('/site-notifications/') || 
            url.includes('/team-info/')
        )) {
            promise.then(response => {
                // Vérifier si la réponse est du JSON
                if (!isJsonResponse(response)) {
                    return response;
                }
                
                // Cloner la réponse pour pouvoir la lire
                const clone = response.clone();
                clone.json().then(data => {
                    // Si la réponse contient le nombre total de notifications non lues, mettre à jour le badge
                    if (data && data.total_unread_count !== undefined) {
                        updateBadge(data.total_unread_count);
                    } else {
                        // Si la réponse ne contient pas le nombre total, faire une requête pour obtenir le nombre actuel
                        fetch('/badge/unread-count')
                            .then(response => response.json())
                            .then(badgeData => {
                                if (badgeData && badgeData.count !== undefined) {
                                    updateBadge(badgeData.count);
                                }
                            })
                            .catch(error => {
                                console.error('Erreur lors de la récupération du nombre de notifications:', error);
                            });
                    }
                }).catch(error => {
                    console.error('Erreur lors de la lecture de la réponse JSON:', error);
                });
                
                return response;
            }).catch(error => {
                console.error('Erreur lors de l\'interception de la réponse:', error);
                return promise; // Retourner la promesse originale en cas d'erreur
            });
        }
        
        return promise;
    };
    
    // Initialiser le badge au chargement de la page
    setTimeout(() => {
        fetch('/badge/unread-count')
            .then(response => {
                if (!isJsonResponse(response)) {
                    throw new Error('La réponse n\'est pas au format JSON');
                }
                return response.json();
            })
            .then(data => {
                if (data && data.count !== undefined) {
                    updateBadge(data.count);
                }
            })
            .catch(error => {
                console.error('Erreur lors de la récupération du nombre de notifications:', error);
            });
    }, 1000); // Attendre 1 seconde pour s'assurer que tout est chargé
});
